export const albumType: any = {
  pozaMiazga: {
    label: 'Przygotowanie do Miazgi',
    name: 'poza_miazga',
    tag: 'PRZED MIAZGĄ',
  },
  pozaMiazgaChallenge: {
    label: 'Przygotowanie do wyzwań',
    name: 'poza_miazga',
    tag: 'PRZED MIAZGĄ',
  },
  treningiMiazga: {
    label: 'MIAZGA',
    name: 'treningi_miazga',
    tag: 'TRENINGI MIAZGA',
  },
  zrobSzpagat: {
    label: 'Zrób szpagat',
    name: 'zrob_szpagat',
    tag: 'ZRÓB SZPAGAT',
  },
  treningiDodatkowe: {
    label: 'Dodatkowe działy treningowe',
    name: 'treningi_dodatkowe',
    tag: 'TRENINGI DODATKOWE',
  },
  dietaKuchnia: {
    label: 'Dieta i kuchnia',
    name: 'dieta_i_kuchnia',
    tag: 'DIETA I KUCHNIA',
  },
  zdrowie: {
    label: 'Zdrowie psychiczne i fizyczne',
    name: 'zdrowie_psychiczne_i_fizyczne',
    tag: 'ZDROWIE',
  },
  newChallenges: {
    label: 'MIAZGA w pigułce',
    name: 'miazga-w-pigulce',
    tag: 'MIAZGA W PIGUŁCE',
  },
}
